import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Autocomplete, Avatar, TextField } from "@mui/material";
import { MultipleQueryTypesense } from "../../../../Typesense";
import { getLocalStorageItem } from "../../../../controllers/localStorage/getLocalStorage";
import { stringAvatar } from "../../../../helpers/stringAvatar";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import "./ClientModal.css";
import LeadForm from "../../../../components/LeadForm/LeadForm";
import GetAllLeads from "../../../../controllers/leads/GetAllLeads";
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import { useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import PlacesAutocomplete from "react-places-autocomplete";
import isDuplicatePhoneNumber from "../../../../controllers/duplicates/isDuplicatePhoneNumber";
import isDuplicateCNIC from "../../../../controllers/duplicates/isDuplicateCNIC";
import CreateLeads from "../../../../controllers/leads/CreateLeads";
import GetSingleLeadData from "../../../../controllers/leads/GetSingleLeadData";
import UpdateSingleLead from "../../../../controllers/leads/UpdateSingleLead";
const style = {
  position: "absolute",
  borderRadius: "10px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  minHeight: "64vh",
};

// Form Validate schema Start
const schema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Name must have at least 3 characters")
    .max(30, "Name must not be more than 30 characters")
    .required("Name is required")
    .default(""),
  phone: yup.string().required("Phone number is required").nullable(),
  email: yup.string().email("Invalid email").default(null).nullable(),
  company: yup.string().default(null).nullable(),
  cnic: yup.string().default(null).nullable(),
  address: yup
    .string()
    .max(500, "Address must not be more than 500 characters")
    .default(null)
    .nullable(),
});

const ClientModal = (props) => {
  const {
    modalStatus,
    setModalStatus,
    client,
    setClient,
    isUpdate,
    dealStatus,
  } = props;

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    setError,
    control,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [inputSearch, setInputSearch] = useState("");
  const [localClients, setLocalClients] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [openClientModal, setOpenClientModal] = useState(true);
  const [address, setAddress] = useState();
  const [clientUpdateFlag, setClientUpdateFlag] = useState(false);
  const [selectedClient, setSelectedClient] = useState();
  const [saveBtnLoader, setSaveBtnLoader] = useState(false);

  const [isItNewClient, setIsItNewClient] = useState(true);
  const [clientDetails, setClientDetails] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    cnic: null,
    address: "",
  });

  useEffect(() => {
    if (isUpdate) {
      setIsItNewClient(false);
      setValue("name", client?.name);
      setValue("phone", client?.phone);
      setValue("email", client?.email);
      setValue("company", client?.company);
      setValue("cnic", client?.cnic);
      setValue("address", client?.address);
      setClientDetails({
        name: client?.name,
        phone: client?.phone,
        email: client?.email,
        company: client?.company,
        cnic: client?.cnic,
        address: client?.address,
      });
    }
  }, [
    isUpdate,
    setValue,
    client?.address,
    client?.company,
    client?.email,
    client?.cnic,
    client?.name,
    client?.phone,
  ]);

  useEffect(() => {
    if (isItNewClient === false) {
      if (client)
        setClient({
          ...client,
          name: clientDetails?.name,
          phone: clientDetails?.phone,
          email: clientDetails?.email ? clientDetails?.email : "",
          company: clientDetails?.company ? clientDetails?.company : "",
          cnic: clientDetails?.cnic ? clientDetails?.cnic : "",
          address: clientDetails?.address ? clientDetails?.address : "",
        });
    }
  }, [isItNewClient, clientDetails]);

  const handleFormSubmit = async () => {
    setSaveBtnLoader(true);

    // Check that it is new client
    if (isItNewClient) {
      //  Phone number validation

      if (
        clientDetails.phone !== "" ||
        clientDetails.phone !== null ||
        clientDetails.phone !== undefined
      ) {
        if (isValidPhoneNumber(clientDetails.phone)) {
          if (await isDuplicatePhoneNumber(clientDetails.phone)) {
            setError("phone", {
              message:
                "This phone number already exists! use a different phone number ",
            });

            setSaveBtnLoader(false);

            return;
          }
        } else {
          setError("phone", {
            message: "Enter a valid phone number",
          });

          setSaveBtnLoader(false);

          return;
        }
      } else {
        setError("phone", {
          message: "Phone Number is required",
        });
        setSaveBtnLoader(false);

        return;
      }

      // Client CNIC validation
      if (clientDetails.cnic !== null) {
        if (clientDetails.cnic.length < 13) {
          setError("cnic", {
            message: "CNIC must be 13 digits",
          });
          // setIsDisabled(false);
          return;
        } else if (await isDuplicateCNIC(clientDetails.cnic)) {
          setError("cnic", {
            message:
              "This cnic number already exists! use a different cnic number ",
          });
          // setIsDisabled(false);
          setSaveBtnLoader(false);
          return;
        }
      }
      console.log("creating lead");
      const leads = await CreateLeads(clientDetails);

      let singleLead = await GetSingleLeadData(leads.id);
      setClient(singleLead);
      setSaveBtnLoader(false);
      handleClose();
    } else {
      // Update client in the firebase
      if (clientUpdateFlag === true) {
        //no duplication check if the user entered the same number
        if (selectedClient.phone !== clientDetails.phone) {
          if (
            clientDetails.phone !== "" ||
            clientDetails.phone !== null ||
            clientDetails.phone !== undefined
          ) {
            if (isValidPhoneNumber(clientDetails.phone)) {
              //checking for duplicates
              if (await isDuplicatePhoneNumber(clientDetails.phone)) {
                setError("phone", {
                  message:
                    "This phone number already exists! use a different phone number ",
                });
                // setIsDisabled(false);
                setSaveBtnLoader(false);
                return;
              }
            } else {
              setError("phone", {
                message: "Enter a valid phone number",
              });
              // setIsDisabled(false);
              setSaveBtnLoader(false);
              return;
            }
          } else {
            setError("phone", {
              message: "Phone Number is required",
            });
            setSaveBtnLoader(false);

            // setIsDisabled(false);
            return;
          }
        }

        // Cnic validation
        if (selectedClient.cnic !== clientDetails.cnic) {
          if (clientDetails.cnic !== null) {
            if (clientDetails.cnic.length < 13) {
              setError("cnic", {
                message: "CNIC must be 13 digits",
              });
              // setIsDisabled(false);
              setSaveBtnLoader(false);

              return;
            } else if (await isDuplicateCNIC(clientDetails.cnic)) {
              setError("cnic", {
                message:
                  "This cnic number already exists! use a different cnic number ",
              });
              setSaveBtnLoader(false);

              // setIsDisabled(false);
              return;
            }
          }
        }

        let resp = await UpdateSingleLead(clientDetails, client.id);

        console.log("update client response ", resp);

        setClientUpdateFlag(false);
      }
      setIsClicked(true);
      setSaveBtnLoader(false);

      if (client) {
        handleClose();
      }
    }
  };

  const handleSelect = async (value) => {
    setAddress(value);
    setClientDetails({
      ...clientDetails,
      address: value,
    });
    setClientUpdateFlag(true);
  };

  // Modal Start
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen("add");
  const handleAddClient = () => {
    // toggleRefresh();
    setOpen(false);
  };
  // Modal End

  const [Refresh, setRefresh] = useState(false);
  useEffect(() => {
    async function fetchData() {
      if (inputSearch.length > 0) {
        const array = [];
        for (let i = 0; i < localClients.length; i++) {
          if (
            localClients[i].name
              .toLowerCase()
              .includes(inputSearch.toLowerCase())
          ) {
            array.push(localClients[i]);
          }
        }
        setLocalClients(array);
      } else {
        const leads = (await GetAllLeads("*", "newest", "*", 1000)).leads;

        setLocalClients(leads);
      }
    }
    fetchData();
  }, [inputSearch, Refresh]);

  const handleClose = () => {
    setIsItNewClient(false);
    // setValue("phone", "");
    // setValue("name", "");

    // setValue("email", "");
    // setValue("company", "");
    // setValue("cnic", "");
    setModalStatus(false);
    setIsClicked(false);
  };

  const toggleRefresh = () => {
    setRefresh(!Refresh);
    setOpen(false);
  };

  console.log("clientDetails", client);
  console.log("clientDetails", clientDetails);

  return (
    <>
      <Modal
        open={modalStatus}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="select-client-modal"
      >
        <>
          <Box sx={style} className="Custom-Modal-Box">
            <div className="client-modal-title">
              <p className="modal-heading">Client</p>
              <div
                className="modal-close-icon"
                onClick={() => {
                  setModalStatus(false);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </div>
            </div>{" "}
            <hr className="mb-4" />
            <div className="client-card-body">
              <div>
                <Autocomplete
                  disabled={dealStatus !== "open"}
                  disablePortal
                  // open={openClientModal}
                  // onOpen={() => setOpenClientModal(true)}
                  // onClose={() => setOpenClientModal(false)}
                  id="combo-box-demo"
                  options={localClients}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  onChange={(event, value, reason, details) => {
                    setClient(value);
                    setSelectedClient(value);
                    if (value) {
                      setIsItNewClient(false);
                      setValue("phone", value?.phone);
                      setValue("name", value?.name);
                      setValue("email", value?.email);
                      setValue("company", value?.company);
                      setValue("cnic", value?.cnic);

                      setClientDetails({
                        name: value.name,
                        phone: value.phone,
                        email: value.email,
                        company: value.company,
                        cnic: value.cnic,
                        address: value.address,
                      });
                      setAddress(value.address);
                    } else {
                      setValue("phone", "");
                      setValue("cnic");
                      setAddress("");
                      setClientDetails({
                        name: "",
                        phone: "",
                        email: "",
                        company: "",
                        cnic: null,
                        address: "",
                      });
                      setClient(null);
                    }
                    if (!client) {
                      // handleClose();
                    }
                  }}
                  getOptionLabel={(option) => option.name ?? ""}
                  // sx={{ width: 300 }}
                  defaultValue={!client ? null : client}
                  onInputChange={(e, newInputValue) => {
                    setInputSearch(newInputValue);
                  }}
                  inputValue={inputSearch ?? ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select a client"
                      hiddenLabel
                      value={inputSearch ?? ""}
                    />
                  )}
                  renderOption={(props, option) => {
                    return (
                      <>
                        <Box
                          style={{
                            display: "flex",
                          }}
                          {...props}
                          key={option.id}
                        >
                          <div className="add-deal-client-dropdown">
                            <Avatar
                              className="add-deal-client-dropdown-avatar"
                              {...stringAvatar(option.name)}
                            />
                          </div>

                          <div className="client-modal-sub-container">
                            <p className="client-name">{option?.name}</p>
                            <p className="client-email">{option?.email}</p>
                            <p className="client-contact">{option?.phone}</p>
                          </div>
                        </Box>
                        <div className="line"></div>
                      </>
                    );
                  }}
                />

                {isClicked && !client && (
                  <small className="errorMssage">Please select a client</small>
                )}
                <div className="mt-4">
                  <div className="input-container">
                    <label className="modal-form-field-label">
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type={"text"}
                      className="form-control  form-input-field"
                      placeholder="name"
                      {...register("name")}
                      value={clientDetails?.name}
                      onChange={(e) => {
                        setClientDetails({
                          ...clientDetails,
                          name: e.target.value,
                        });
                        setClientUpdateFlag(true);
                      }}
                      disabled={dealStatus !== "open"}
                    />
                    <p className="errorMessage"> {errors.name?.message} </p>
                  </div>
                  <div className="input-container-phone">
                    <label className="modal-form-field-label">
                      Phone <span style={{ color: "red" }}>*</span>
                    </label>

                    <PhoneInputWithCountry
                      name="phone"
                      className={`form-control ${
                        dealStatus !== "open"
                          ? "disable-form-phone-input-field"
                          : "form-phone-input-field"
                      }`}
                      placeholder="name"
                      defaultCountry={"PK"}
                      international={true}
                      countryCallingCodeEditable={false}
                      initialValueFormat="national"
                      control={control}
                      // disabled={isDisabled}
                      // defaultValue={clientDetails?.phone}
                      rules={{
                        validate: (value) => isValidPhoneNumber(value),
                        required: true,
                      }}
                      style={{ border: "none !important" }}
                      onChange={(value) => {
                        setClientDetails({
                          ...clientDetails,
                          phone: value,
                        });
                        setClientUpdateFlag(true);
                      }}
                      disabled={dealStatus !== "open"}
                    />
                    {errors?.phone && (
                      <p className="errorMessage"> {errors.phone?.message} </p>
                    )}
                  </div>
                  <div className="input-container mt-4">
                    <label className="modal-form-field-label">Email</label>

                    <input
                      type={"email"}
                      className="form-control  form-input-field"
                      placeholder="Email"
                      value={clientDetails.email}
                      {...register("email")}
                      onChange={(e) => {
                        setClientDetails({
                          ...clientDetails,
                          email: e.target.value,
                        });
                        setClientUpdateFlag(true);
                      }}
                      disabled={dealStatus !== "open"}
                    />
                    <p className="errorMessage"> {errors.email?.message} </p>
                  </div>
                  <div className="input-container">
                    <label className="modal-form-field-label">Company</label>

                    <input
                      type={"text"}
                      className="form-control  form-input-field"
                      placeholder="company"
                      value={clientDetails.company}
                      {...register("company")}
                      onChange={(e) => {
                        setClientDetails({
                          ...clientDetails,
                          company: e.target.value,
                        });
                        setClientUpdateFlag(true);
                      }}
                      disabled={dealStatus !== "open"}
                    />

                    <p className="errorMessage"> {errors.company?.message} </p>
                  </div>
                  <div className="input-container">
                    <label className="modal-form-field-label">CNIC</label>

                    <NumberFormat
                      format="#####-#######-#"
                      // allowEmptyFormatting={" "}
                      // mask=" "
                      type="text"
                      className="form-control  form-input-field"
                      placeholder="cnic"
                      name="cnic"
                      {...register("cnic")}
                      value={clientDetails?.cnic}
                      onChange={(e) => {
                        setClientDetails({
                          ...clientDetails,
                          cnic: e.target.value.replaceAll("-", "").trim(),
                        });
                        setClientUpdateFlag(true);
                      }}
                      defaultValue={clientDetails?.cnic}
                      // onChange={(e) => {
                      //   setValue("cnic", e.target.value.replaceAll("-", "").trim());
                      // }}
                      // onChange={(e) => setValue("cnic", e.target.value)}
                      // value={Phone}
                      // {...phoneRegister("phone", { required: true })}
                      // disabled={isDisabled}
                      disabled={dealStatus !== "open"}
                    />
                    <p className="errorMessage">{errors.cnic?.message} </p>
                  </div>

                  <div className="input-container select-client-address">
                    <label className="modal-form-field-label">Address</label>
                    <PlacesAutocomplete
                      value={address}
                      onChange={(e) => {
                        setAddress(e);
                        setValue("address", e);
                      }}
                      onSelect={handleSelect}
                      searchOptions={{
                        componentRestrictions: { country: "pk" },
                      }}
                      // className="loc-auto-complete-client"
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => (
                        <div>
                          <input
                            className="location-input-style"
                            {...getInputProps({ placeholder: "Address" })}
                            disabled={dealStatus !== "open"}
                          />

                          <div>
                            {loading ? (
                              <div className="loc-auto-complete-content">
                                loading...
                              </div>
                            ) : null}

                            {suggestions.map((suggestion) => {
                              const style = {
                                backgroundColor: suggestion.active
                                  ? "#c9c2e4"
                                  : "#fff",
                              };

                              return (
                                <div
                                  className="loc-auto-complete-content"
                                  {...getSuggestionItemProps(suggestion, {
                                    style,
                                  })}
                                  key={suggestion.placeId}
                                >
                                  {suggestion.description}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>

                    <p className="errorMessage"> {errors.address?.message} </p>
                  </div>
                </div>
              </div>

              <Box className="add-deal-btn-container">
                <button
                  className="close-modal-btn "
                  onClick={() => {
                    reset();

                    setModalStatus(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="form-submit-button"
                  disabled={saveBtnLoader || dealStatus !== "open"}
                  onClick={handleSubmit((e) => {
                    handleFormSubmit();
                  })}
                >
                  {saveBtnLoader ? (
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only"></span>
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </Box>
            </div>
          </Box>
        </>
      </Modal>

      <LeadForm
        {...{
          open,
          setOpen,
          SingleLeadData: null,
          setSingleLeadData: () => {},
          LeadId: "",
          handleRefresh: toggleRefresh,
        }}
      />
    </>
  );
};

export default ClientModal;
